module.exports = __webpack_public_path__ + "static/media/share-card-close.aa032e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/share-card-close.png
// module id = 2148
// module chunks = 4